module.exports = __webpack_public_path__ + "img/wohin-sollen.45740c21.svg";